import { GroupSelect } from "./groupSelect/GroupSelect.connector";
import { TitleSymbolField } from "./TitleSymbolField.connector";
import { useWorkspaceWidgetController } from "./WorkspaceWidget.controller";
import { WorkspaceWidgetPresentation } from "./WorkspaceWidget.pres";

export interface WorkspaceWidgetProps {
  id: string;
}

/**
 * Symbol resolution is not tunnelled through here — each sub-connector receives
 * only `{ id }` and selects its own effective symbol from the same store.
 *
 * Layout presentations must never import or render this component directly; the
 * tab connector passes it via `renderWidget`.
 *
 * `onReset` (error-boundary recovery) is intentionally not wired yet — a local
 * remount is sufficient for now.
 */
export const WorkspaceWidget = ({ id }: WorkspaceWidgetProps) => {
  const controller = useWorkspaceWidgetController({ id });

  if (controller.kind === undefined) {
    return null;
  }

  const {
    title,
    titleSymbolValue,
    titleSymbolError,
    titleEditorOn,
    accentColor,
    groupLinePosition,
    showGroupSelect,
    WidgetBody,
    onRemove,
    onTitleSymbolCommit,
  } = controller;

  return (
    <WorkspaceWidgetPresentation
      id={id}
      title={title}
      titleSymbol={
        titleEditorOn ? (
          <TitleSymbolField
            value={titleSymbolValue}
            onCommit={onTitleSymbolCommit}
            error={titleSymbolError}
          />
        ) : undefined
      }
      accentColor={accentColor}
      groupLinePosition={groupLinePosition}
      onRemove={onRemove}
      headerAccessory={
        showGroupSelect ? <GroupSelect widgetId={id} /> : undefined
      }
    >
      <WidgetBody id={id} />
    </WorkspaceWidgetPresentation>
  );
};
